define('lq/layouting',[],function () {
    'use strict';

    var cssRules = undefined;

    var applyLayout = function ($target, currentLayout) {
        $target
            .removeClass(function (index, className) {
                return className.lastIndexOf('using-layout-', 0) !== 0;
            });

        if (!currentLayout) return;

        $target
            .addClass('with-layout using-layout-' + currentLayout.id);

        if (!cssRules) {
            cssRules = document.createElement('style');
            document.body.appendChild(cssRules);
        }

        cssRules.innerHTML = '.with-layout.using-layout-' + currentLayout.id + ' .layout-specific:not(.supports-layout-' + currentLayout.id + ') {' +
            '   visibility: hidden !important;' +
            '}';
    };

    return {

        applyLayout: applyLayout

    };

});
